"use strict";

var idCounter = 0;
/**
 * Generates a unique ID.
 *
 * @returns {number} Returns the unique ID.
 */
module.exports = function () {
  return ++idCounter;
};